module.exports = __webpack_public_path__ + "img/Best of Schaumwein.bdead2a2.jpg";